import { Modal } from 'platform-components';
import React, { ReactElement } from 'react';

interface Props {
    children: ReactElement[];
    mix?: string;
    stackable?: boolean;
}

export const NewYearModalControls = ({ stackable, children, mix }: Props) => {
    return (
        <Modal.Footer mix={mix} stackable={stackable}>
            {children}
        </Modal.Footer>
    );
};
